import { Heading } from '@chakra-ui/layout';
import React from 'react';
import Layout from '../../components/Layout';
import classes from './styles.module.scss';
import { BRAND_NAME } from '../../constants';

export default function PrivacyPolicy() {
  return (
    <Layout>
      <div className={classes.PrivacyPolicy}>
        <Heading as="h1">Privacy Policy</Heading>
        <p>
          As we update, improve and expand {BRAND_NAME} App Services, this
          policy may change, so please refer to it periodically. By accessing
          the website/app or otherwise using {BRAND_NAME} App Services, you give
          us your consent to collect, store, and use the information you provide
          (including any changes thereto as provided by you) for any of the
          services that we offer.
        </p>
        <p>
          <strong> Note:</strong> Our privacy policy may change at any time
          without prior notification. To make sure that you are aware of any
          changes, kindly review the policy periodically. This Privacy Policy
          shall apply uniformly to {BRAND_NAME} App desktop website,
          {BRAND_NAME} App mobile WAP site &amp;{BRAND_NAME} App mobile
          applications.
        </p>
        <Heading as="h4" size="md">
          Information you give us to avail our services on {BRAND_NAME} App
        </Heading>
        <p>
          You are required to provide the following information for the
          registration/ login process:-
          <ol type="a" className={classes.parentList}>
            <li>
              Mobile Number: We verify and validate the mobile number provided
              by you as all rewards are given based on this number. Other uses:
              <ol type="i" className={classes.childList}>
                <li>
                  Mobile number is also used in assisting you in case of any
                  account related queries raised by you.
                </li>
                <li>
                  Mobile number is also used to communicate account related
                  activities and custom offers occasionally.
                </li>
              </ol>
            </li>
            <li>
              Email address: Your email address is used to communicate service
              alerts (your activity on {BRAND_NAME} App &amp;Service related
              communication). Other uses :
              <ol type="i" className={classes.childList}>
                <li>
                  We verify your email address through 3<sup>rd</sup> party
                  services to detect fraud/ unauthorised usage of {BRAND_NAME}
                  App.
                </li>
                <li>
                  We send commercial or marketing messages which we deem to be
                  relevant to you, with an option to unsubscribe in each email.
                  We shall not send you any email communication if you choose to
                  unsubscribe from these messages.
                </li>
              </ol>
              <li>
                Name &amp; PAN Card number: Your PAN is used to verify your
                identity.
                <ol type="i" className={classes.childList}>
                  <li>
                    We verify your PAN card through 3<sup>rd</sup> party
                    services to ensure genuine usage of {BRAND_NAME} App and
                    allow you to earn from {BRAND_NAME} App.
                  </li>
                </ol>
              </li>
              <li>
                Bank Account information : You Bank account information is used
                to ensure payout is provided only to your bank account that
                matches with your name on PAN card.
                <ol type="i" className={classes.childList}>
                  <li>
                    We verify your Bank information through 3rd party services
                    to ensure genuine usage and that your payouts happen in only
                    your bank accounts
                  </li>
                </ol>
              </li>
            </li>
          </ol>
        </p>
        <p>
          These information are stored in an encrypted format. All required
          information is service dependent and the Company may use the above
          said user Information to maintain, protect, and improve the
          {BRAND_NAME} App Services and for developing new services.
        </p>
        <p>
          In case you choose to decline to submit your mobile number &amp;email
          address information on the app during registration, we will not be
          able to provide services on the app to you. We will make reasonable
          efforts to notify you of the same at the time of opening your account.
        </p>
        <p>
          When you register with the {BRAND_NAME} App Services, we contact you
          from time to time about updating your personal information to provide
          you features that we believe may benefit / interest you. By agreeing
          to this privacy policy, you explicitly give us consent to use your
          information as described in this privacy policy.
          <strong>
            If you do not agree, please do not use or access {BRAND_NAME} App
            services.
          </strong>
        </p>
        <p>
          After registration is complete, users can optionally choose to furnish
          below information via the Profile section within {BRAND_NAME} App:-
        </p>
        <ol type="a" className={classes.parentList}>
          <li>Location information including address</li>
          <li>
            Personal information including name, date of birth, gender,
            education, profession, marital status, number of children, TV
            connection, internet connection
          </li>
          <li>Occupation &amp; interests</li>
          <li>
            Other Miscellaneous Information: vehicle ownership detail,
            accommodation, if you own a credit card (Y/N), pet ownership &
            gadget ownership.
          </li>
        </ol>
        <p>
          Above information is completely voluntary and you can choose to not
          provide the same. The above Information as supplied by you enables us
          to improve the {BRAND_NAME} App services and provide you custom
          offers.
        </p>
        <p>
          Information we capture/ track from use of the services or is obtained
          from third parties (this information is only captured from your device
          after you grant permission to {BRAND_NAME} App). We capture/ track
          information from your use of services. This information may be
          obtained from third parties in some cases. This information is used to
          provide best &amp;customized service to each of our users, improve
          overall service delivery, devise new services, identify and reduce
          fraud or un-authorized use of our services and other purposes. All
          this information is captured after your explicit confirmation and
          permissions wherever required. Information tracked has been mentioned
          below to give details of the same.
        </p>
        <ol className={classes.parentList}>
          <li>
            <strong>Device &amp; account information</strong> <br />
            We collect device-specific information (such as your hardware model,
            operating system version, unique device identifiers, and mobile
            network information including phone number and account information
            on phone).
            <br />
            <strong> How we use this information</strong> <br /> We primarily
            use this information to detect fraud &amp; unauthorized usage of
            {BRAND_NAME} App services. Your device level information is also
            used in tracking your activity on {BRAND_NAME} App for various
            actions &amp; tasks.
          </li>
          <li>
            <strong>Log information</strong> <br />
            When you use our services or view content provided by {BRAND_NAME}
            App, we automatically collect and store certain information in
            server logs. This includes:
            <ol type="a" className={classes.childList}>
              <li>details of how you used our service</li>
              <li>reading SMS Messages for the purpose of OTP verification</li>
              <li>internet protocol address.</li>
              <li>
                device event information such as crashes, system activity,
                hardware settings, the date and time of your request and
                referral URL.
              </li>
              <li>
                cookies that may uniquely identify your browser or your
                {BRAND_NAME}
                App Account.
              </li>
            </ol>
            <strong> How we use this information</strong> <br /> We read SMS
            messages &amp; routing information only for mobile number
            verification purposes for registration/ signup on {BRAND_NAME} App.
            We do not read messages send by any service other than {BRAND_NAME}
            App itself. We use information collected from cookies and other
            technologies, like pixel tags etc. to improve your user experience
            and the overall quality of our services. We use multiple such 3rd
            party services like Google Analytics, Branch metrics etc. We may
            combine personal information from one service with information,
            including personal information, from other services to create a rich
            profile of you , to better your experience on {BRAND_NAME} App.
          </li>
          <li>
            <strong>Location information</strong> <br />
            When you use {BRAND_NAME} App services, we may collect and process
            information about your location. We use various technologies to
            determine location, including IP address, GPS, and other sensors
            that may, for example, provide {BRAND_NAME} App with information on
            nearby devices, Wi-Fi access points and cell towers.
            <br />
            <strong> How we use this information</strong> <br />
            We use location information to maintain &amp;improve services
            provided to you, to develop new services. These services include
            those provided to users within the app and via email communications
            that we shall send to you as mentioned above. We also use this
            information to offer you tailored &amp;customized offers within the
            app, website and emails.
          </li>
          <li>
            <strong>Unique application numbers</strong> <br />
            Certain services include a unique application number. This number
            and information about your installation (for example, the operating
            system type, application version number, etc..) may be sent to
            {BRAND_NAME}
            App when you install or uninstall that service.
            <br />
            <strong> How we use this information</strong> <br />
            Operating system type &amp; version helps us in providing best
            experience of {BRAND_NAME} App for your operating system along with
            customizing offers displayed to you. Information about Installing
            and uninstalling of other services helps us in keeping track of
            offers that are common between these and {BRAND_NAME} App and thus
            giving you the best experience and performance within the app.
          </li>
          <li>
            <strong>Local storage</strong> <br />
            We may collect and store information locally on your device using
            mechanisms such as application data, caches.
            <br />
            <strong> How we use this information</strong> <br />
            This information is used to (a) maintain your login session on
            {BRAND_NAME}
            App (b) this information may also be used from time-to-time to sync
            with {BRAND_NAME} App servers and update the tasks and services that
            we provide to you within the app for your next usage.
          </li>
          <li>
            <strong>Cookies and similar technologies</strong> <br />
            We and our partners use various technologies to collect and store
            information when you visit a {BRAND_NAME} App service, and this may
            include using cookies or similar technologies to identify your
            browser or device. We also use these technologies to collect and
            store information when you interact with the services we offer to
            our partners, such as advertising services or {BRAND_NAME} App
            features that may appear on other sites or various SDKs we use for
            product Analytics that help us analyse the traffic.
            <br />
            <strong> How we use this information</strong> <br />
            We use information collected from cookies and other technologies
            like pixel tags, Postbacks etc. to improve your user experience and
            the overall quality of our services. We use multiple tools &amp;3rd
            party services like Google Analytics, Branch metrics etc. We may
            combine personal information from one service with information,
            including personal information, from other services to give you the
            best experience within {BRAND_NAME} App.
          </li>
        </ol>
        <Heading as="h4" size="md">
          Information we share
        </Heading>
        <p>
          We do not share your personal information with companies,
          organizations and individuals outside of {BRAND_NAME} App &amp; its
          partner companies unless one of the following circumstances applies:
        </p>
        <ol type="a" className={classes.parentList}>
          <li>
            <strong> With your consent</strong> <br />
            <ul className={classes.childList}>
              <li>
                We will share device level information with companies,
                organizations or individuals outside of {BRAND_NAME} App when we
                have your consent to do so. When you agree to our Privacy
                Policy, you provide us consent to share your device level
                information (mainly used for analytics and marketing purpose).
                We do not share your personally identifiable information with
                any entity outside {BRAND_NAME} App.
              </li>
            </ul>
          </li>
          <li>
            <strong>
              We may disclose to third party services certain personally
              identifiable information listed below:
            </strong>
            <br />
            <ul className={classes.childList}>
              <li>
                information you provide us such as email, mobile phone number,
                etc.
              </li>
              <li>
                information we collect as you access and use our service,
                including contacts in your device, application packages present
                on your device, email addresses, and third party accounts
                information on your phone, device information, location, network
                carrier, messages etc.
              </li>
            </ul>
          </li>
          <li>
            <strong>
              This information is shared with third-party service providers so
              that we can:
            </strong>
            <br />
            <ul className={classes.childList}>
              <li>personalize the app for you</li>
              <li>perform behavioural analytics</li>
              <li>
                provide advertisements about goods and services of interest to
                you
              </li>
            </ul>
            Once the User permits, we may obtain additional information such as
            transactional information available on your device, to personalise
            your experience and improve the app suggestions. Please be informed
            that the data collection is handled securely, including transmitting
            it using modern cryptography (secure HTTPS connection).
          </li>
          <li>
            <strong>For external processing</strong> <br />
            <ul className={classes.childList}>
              <li>
                We provide information to our affiliates or other trusted
                businesses or persons to process it for us, based on our
                instructions and in compliance with Privacy Policy and any other
                appropriate confidentiality and security measures.
              </li>
            </ul>
          </li>
          <li>
            <strong> For legal reasons</strong> <br />
            We will share personal information with companies, organizations or
            individuals outside of {BRAND_NAME} App &amp; its partner companies
            due to various legal reasons
            <ul className={classes.childList}>
              <li>
                meet any applicable law, regulation, legal process or
                enforceable governmental request.
              </li>
              <li>
                enforce applicable Terms of Service, including investigation of
                potential violations.
              </li>
              <li>
                detect, prevent, or otherwise address fraud, security or
                technical issues.
              </li>
              <li>
                protect against harm to the rights, property or safety of
                {BRAND_NAME}
                App &amp; its partner companies, our users or the public as
                required or permitted by law.
              </li>
            </ul>
          </li>
        </ol>
        <p>
          We may share non-personally identifiable information with our partners
          like publishers, advertisers or connected sites. For example, we may
          share information publicly to show trends about the general use of our
          services.
        </p>
        <p>
          Personally identifiable information may be transferred as an asset in
          connection with a merger or sale (including any transfers made as part
          of an insolvency or bankruptcy proceeding) involving all or part of
          our business or as part of a corporate reorganization, stock sale, or
          other change in control. Your visit and any dispute over privacy are
          subject to this policy and our terms and conditions, including
          limitations on damages. <br />
          <br /> We will only share your personal information with other
          companies or individuals outside of {BRAND_NAME} App &amp; its partner
          companies in the following circumstances:
          <ul className={classes.parentList}>
            <li>
              As necessary to process your transactions and to maintain your
              account.
            </li>
            <li>
              To complete your registration for a service provided by a third
              party
            </li>
          </ul>
        </p>
        <p>
          The information that we collect, including information obtained from
          third parties, is shared with our affiliates, meaning other companies
          owned, controlled or are in partnership with {BRAND_NAME} App. Our
          affiliates, which can be financial and non-financial entities, will
          use such information for their everyday business purposes.
        </p>
        <Heading as="h4" size="md">
          Links to third party sites / services
        </Heading>
        <p>
          {BRAND_NAME} App Site/ App may include links to other websites or
          apps. Such sites are governed by their respective privacy policies,
          which are beyond our control. Once you click on those links, use of
          any information you provide is governed by the privacy policy of the
          operator of the site you are visiting. That policy may differ from
          ours. If you can't find the privacy policy of any of these sites via a
          link from the site's homepage, you should contact the site directly
          for more information.
        </p>
        <p>
          Any information you provide directly to a third party merchant;
          website or application is not covered by this privacy notice. We are
          not responsible for the privacy or security practices of merchants or
          other third parties with whom you choose to share your personal
          information directly. We encourage you to review the privacy policies
          of any third party to whom you choose to share your personal
          information directly.
        </p>
        <Heading as="h4" size="md">
          Information Security
        </Heading>
        <p>
          {BRAND_NAME} App has security measures in place to protect the loss,
          misuse, and alteration of the information under our control. Whenever
          you change or access your account information, we offer the use of a
          secure server. Once your information is in our possession we adhere to
          strict security guidelines, protecting it against unauthorized access.
        </p>
        <Heading as="h4" size="md">
          Permissions that we require
        </Heading>
        <p>
          {BRAND_NAME} App app for Android requires following permissions to
          perform normally on your device:-
        </p>
        <ol className={classes.parentList}>
          <li>
            Device &amp; app history - Retrieve apps that are currently running
            on your device
          </li>
          <li>
            Identity - Get details about different device identifiers for your
            device
          </li>
          <li>
            Contacts - Find &amp; read email accounts currently associated on
            your phone and associate them with your account on {BRAND_NAME} App
          </li>
          <li>
            Location - Get location of your device and associate it with your {BRAND_NAME} App account so as to improve delivered services get
            better business lead.
          </li>
          <li>
            SMS - Primary to read and Verify OTP SMS for {BRAND_NAME} App signup
            and registration process. We may also use it for Analytics,
            Marketing &amp; Targeting purposes.
          </li>
          <li>
            Phone Status - Keep app performance optimized for various statuses
            of your phone, such as locked / unlocked status etc.
          </li>
          <li>
            Photos/Media/Files &amp; Storage Access - We only read and access
            various files stored by {BRAND_NAME} App app on your device to keep
            the performance optimized.
          </li>
          <li>
            Wi-Fi connection information - We read the status of Wi-Fi
            connection on your device to notify you about the same and also
            intimate you to use {BRAND_NAME} App at that time so as to save on
            your data costs
          </li>
          <li>
            Other Permissions such as: Receive data from Internet, full network
            access, prevent device from sleeping, reorder running apps, view
            network connections, read Google service configuration, control
            vibration, run at start-up, modify system settings. We use these
            services to give our users best possible experience on {BRAND_NAME}
            App and improve our services from time to time.
          </li>
        </ol>
        <Heading as="h4" size="md">
          Grievance Contact information
        </Heading>
        In the event you have any grievance relating to the processing of
        information provided by you, you may contact us at&nbsp;
        <a
          href="mailto:incashappofficial@gmail.com"
          target="_blank"
          rel="noreferrer noopener"
        >
          incashappofficial@gmail.com
        </a>
      </div>
    </Layout>
  );
}
